<template>
    <b-container>
        <b-row class="justify-content-md-center" style="margin-top: 100px;">
            <b-col col lg="2"></b-col>
            <b-col cols="12" md="auto">
                <b-card title="Iniciar sessió"
                        img-src="/img/solaris-small.png"
                        img-alt="Image"
                        img-top
                        class="text-center"
                        style="padding: 20px;"
                >
                    <b-form @submit="onSubmit">
                        <b-form-group
                                id="lblEmail"
                                label="Usuari:"
                                label-for="txtEmail"
                        >
                            <b-form-input
                                    id="txtEmail"
                                    type="email"
                                    v-model="form.email"
                                    required
                                    placeholder="Introdueix el teu email"/>
                        </b-form-group>

                        <b-form-group id="lblPassword" label="Contrasenya:" label-for="txtPassword">
                            <b-form-input
                                    id="txtPassword"
                                    type="password"
                                    v-model="form.password"
                                    required
                                    placeholder="Introdueixi contrasenya"/>
                        </b-form-group>

                        <b-button type="submit" variant="primary">Iniciar sessió</b-button>

                        <b-alert variant="danger" v-model="hasErrors">
                            {{ errorMessage }}
                        </b-alert>
                    </b-form>
                </b-card>
            </b-col>
            <b-col col lg="2"></b-col>
        </b-row>
    </b-container>
</template>

<script>
    import api from '../api/index.js'

    export default {
        data() {
            return {
                form: {
                    email: '',
                    password: ''
                },
                hasErrors: false,
                errorMessage: null
            }
        },
        methods: {
            onSubmit(evt) {
                this.hasErrors = false
                this.errorMessage = null
                evt.preventDefault()
                api.authenticate(this.form.email, this.form.password)
                    .then(response => {
                        let data = response.data
                        let token = 'Bearer ' + data.token

                        //Store use and token to Local Storage (for browser refresh)
                        localStorage.user = JSON.stringify(data.user)
                        localStorage.token = token

                        //Store user and token to Vuex Store
                        this.$store.commit('setUser', data.user)
                        this.$store.commit('setToken', token)

                        //Push router to main dashboard route
                        this.$router.push('/dashboard')
                    })
                    .catch(error => {
                        this.hasErrors = true
                        if (error.response.status === 401) {
                            this.errorMessage = "Les credencials no són vàlides"
                        } else {
                            this.errorMessage = "S'ha produit un error al contactar amb el servidor"
                        }
                    })
            }
        }
    }
</script>
